// The countries where signed-out visitors see the safe gallery on the explicit landing pages, while the
// `signed_out_safe_countries` flag is on (src/lib/signed-out-showcase.js). Two capital letters, as Vercel's
// `x-vercel-ip-country` sends them. An unknown country (`ZZ`) always counts, so it is not listed here.
export const SIGNED_OUT_GATED_COUNTRIES = ['GB', 'AU']
